'use strict';

const Mn = require('backbone.marionette');
const Template = require('common/ui/template/modal/index.hbs');
const FooterTemplate = require('common/ui/template/modal/footer.hbs');

const MODAL_CONTAINER = '#modal-container';

const DefaultFooterView = Mn.View.extend({
    template: FooterTemplate,
    triggers: {
        'click .cancel': 'cancel',
        'click .save': 'save'
    }
});

/**
 * Modal に wrap して表示するための View
 *
 * bodyView に Modal 化したい View を設定することで、
 * 手軽に Modal を利用することができるとともに、
 * Modal から View を切り離して再利用性を向上させます。
 *
 * Modal 下部のボタン(保存、キャンセル etc)は
 * footerView で設定することができます。
 * デフォルトで 保存・キャンセル の 2 つのボタンを用意した
 * footerView を用意しているので、通常はそれで足りると思います。
 *
 * footerView でボタン押下時に発火する triggers を設定し、
 * それを onChildviewXXXX として Modal 側に設定することで、
 * ボタン押下時にアクションを実行できます。
 * (詳細は marionettejs の Events 参照)
 *
 * title や modalID はそれぞれ Modal の title や id に対応しています。
 * a タグなどで Modal を起動する場合を除けば特に modalID の指定は不要です。
 *
 * 2 度押しを防げるように disableButtons と enableButtons というメソッドで
 * footerView の .btn を disabled にできます。
 *
 * # 利用例
 *
 * ```
 * const modal = new ModalView({
 *     title: '最高のモーダル',
 *     modalID: 'my-best-modal',
 *     bodyView: new BodyView({model: this.model}),
 *     // 必要なら footerView を設定
 *     // footerView: new MyFooterView(),
 *
 *     // 保存ボタンが押された後の処理
 *     onChildviewSave: function() {
 *         // 2 度押しされないように disable にする
 *         this.disableButtons();
 *         // 諸々処理
 *         // モーダルを隠す
 *         this.hide();
 *     }
 * });
 * modal.show();
 * ```
 */
module.exports = Mn.View.extend({
    template: Template,
    ui: {
        modal: '.modal',
    },
    events: {
        'click .close': 'hide'
    },
    regions: {
        body: '.modal-body',
        footer: '.modal-footer'
    },
    childViewEvents: {
        'cancel': 'hide',
        'formFilled': 'enableButtons',
        'formEmpty': 'disableSaveButton'
    },
    title: '',
    modalID: '',
    large: false,

    serializeData: function() {
        return {
            title: this.getOption('title'),
            modalID: this.getOption('modalID')
        };
    },

    templateContext: function() {
        return {
            isLarge: this.getOption('large')
        }
    },

    onRender: function() {
        this.showChildView('body', this.getOption('bodyView'));
        const footerView = this.getOption('footerView') ? this.getOption('footerView') : new DefaultFooterView();
        this.showChildView('footer', footerView);
        if(!this.getOption('saveButtonEnable')) {
            this.disableSaveButton();
        }
        this.$('input').on('keypress', function(e) {
            // if Enter key press...
            if (e.which == 13) {
                return false;
            }
        });
    },

    show: function() {
        $(MODAL_CONTAINER).append(this.render().el);
        this.ui.modal.modal('show');
        this.ui.modal.on('shown.bs.modal', () => {
            $.material.init();
        });

        // 通常の Marionette.View であれば、親のViewがDOMにAttachされたタイミングで子のViewに対して onAttach が発火する。
        // この ModalView では、 DOM に attach する処理を時前で記述しているために Attach イベントが発火しないので、手動で代替する。
        if (this.getOption('bodyView').onAttach) {
            this.getOption('bodyView').onAttach();
        }
    },

    hide: function() {
        if (this.getOption('cancelButtonDisabled')) {
            return;
        }

        this.ui.modal.modal('hide');
        this.remove();
    },

    disableSaveButton: function () {
        this.getChildView('footer').$('.save').attr('disabled', 'disabled');
    },

    disableButtons: function () {
        this.getChildView('footer').$('.btn').attr('disabled', 'disabled');
    },

    enableButtons: function () {
        this.getChildView('footer').$('.btn').attr('disabled', null);
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/modal/index.js